var map = {
	"./aws.png": 715568,
	"./azure.png": 238034,
	"./bash.png": 773965,
	"./claude.png": 96489,
	"./copilot.png": 450967,
	"./cpp.png": 725716,
	"./css.png": 877394,
	"./datadog.png": 902529,
	"./docker.png": 12667,
	"./dotnet.png": 34521,
	"./github-actions.png": 790416,
	"./html.png": 922936,
	"./javascript.png": 540878,
	"./kubernetes.png": 775259,
	"./nodejs.png": 314446,
	"./python.png": 658985,
	"./redux.png": 605001,
	"./sql.png": 772611,
	"./typescript.png": 205398
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 593012;